// extracted by mini-css-extract-plugin
module.exports = {"BannerAnimation":"BannerAnimation_BannerAnimation__GCm9s"};